<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['values', 'labels'],
  mounted () {
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          label: 'Quantidade de pessoas',
          backgroundColor: '#2d579b',
          data: this.values
        }
      ]
    })
  }
}
</script>
